import { Stack } from '@mui/material';
import CopyrightIcon from '@mui/icons-material/Copyright';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CopyrightAppBar, CopyrightDivider, CopyrightLink, CopyrightTypography } from './copyrightBarStyles';
import { useRouteNavigator } from '../../../routes/useRouteNavigator';
import { CompanyName, CompanyRegistered } from '../../../helpers/clientConfigs';

export function CopyrightBar() {
  const routeNavigator = useRouteNavigator();
  const { t } = useTranslation(['copyright']);
  const [currentYear] = useState(() => new Date().getFullYear());

  return (
    <CopyrightAppBar elevation={0} position="static">
      <CopyrightDivider />
      <Stack direction="row" justifyContent="center" alignItems="baseline">
        <CopyrightIcon sx={{ fontSize: '15px', mr: '5px' }} />
        <CopyrightTypography>
          {' '}
          {CompanyRegistered}-{currentYear} UAB {CompanyName}
        </CopyrightTypography>
      </Stack>
      <CopyrightTypography>{t('copyright:info', { companyName: CompanyName })}</CopyrightTypography>
      <CopyrightLink onClick={() => routeNavigator.goToSupport()}>{t('copyright:contactUs')}</CopyrightLink>
    </CopyrightAppBar>
  );
}
